import { render, staticRenderFns } from "./JobBoard.vue?vue&type=template&id=c5043ede&scoped=true&"
import script from "./JobBoard.vue?vue&type=script&lang=js&"
export * from "./JobBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5043ede",
  null
  
)

export default component.exports